var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEditarLinha01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1236",
    d: "M29.3,5.2c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.3-3-1.3c-1.1,0-2.2,0.4-3,1.2l6,6.1 C28.9,7.4,29.3,6.3,29.3,5.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_456",
    x: 6.9,
    y: 9.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.643 15.7803)",
    width: 19.7,
    height: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1237",
    d: "M6,19.4l-1.4,6.2l6.2-1.4L6,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1238",
    d: "M34.4,33.2H1.6c-0.5,0-1,0.4-1,1s0.4,1,1,1h32.8c0.5,0,1-0.4,1-1S34.9,33.2,34.4,33.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditarLinha01);
export default __webpack_public_path__ + "static/media/ico-editar-linha-01.8cef2b461e625197e75698b007bd5ba8.svg";
export { ForwardRef as ReactComponent };